// Allow this file to be used external to Django templates, like our
// base.html that defines `Mustache.templates`
if (typeof window.Mustache === 'undefined') {
  window.Mustache = {};
}

// Mustache defines a `.to_html` function - perform the import
// and merge the objects if it's already defined.
if (typeof window.Mustache.to_html === 'undefined') {
  // eslint-disable-next-line
  const MustacheModule = require('mustache');
  window.Mustache = { ...window.Mustache, ...MustacheModule };
}

export default window.Mustache;



// WEBPACK FOOTER //
// ../globals/Mustache.js